// reach_ui/src/components/VastGPT/ChatsList.js
import React, { useState, useCallback } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  IconButton,
  Menu,
  MenuItem,
} from '@material-ui/core'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import DeleteIcon from '@material-ui/icons/Delete'
import { selectChat } from './redux'
import { deleteEntity } from '../../actions/data'
import { DATA_API_URL } from '../../utils/AllURLs'

const mapStateToProps = state => ({
  chats: Object.values(state.data?.openaichat || {}).sort(
    (a, b) => new Date(b.updated_date) - new Date(a.updated_date),
  ),
  selectedChatId: state.VastGPT.selectedChatId,
  username: state.auth?.session?.idToken?.payload?.username,
  customVrRole: state.auth?.session?.idToken?.payload?.['custom:vr_role'],
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ selectChat, deleteEntity }, dispatch)

function insertDelimiters(arrayOfObjects) {
  const now = new Date()
  let lastDelimiter = null
  const resultArray = []

  // Sort the array by updated_date in descending order
  const sortedArray = arrayOfObjects.sort(
    (a, b) => new Date(b.updated_date) - new Date(a.updated_date),
  )

  sortedArray.forEach(obj => {
    const objDate = new Date(obj.updated_date)
    const timeDiff = now - objDate // difference in milliseconds
    const dayDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24)) // convert ms to days
    let delimiterType = null

    // Determine the appropriate delimiter
    if (dayDiff === 0) {
      delimiterType = 'Today'
    } else if (dayDiff === 1) {
      delimiterType = 'Yesterday'
    } else if (dayDiff <= 7) {
      delimiterType = 'Previous 7 Days'
    } else if (dayDiff <= 30) {
      delimiterType = 'Previous 30 Days'
    } else {
      delimiterType = 'Older'
    }

    // Insert the delimiter if it hasn't been inserted yet or if it has changed
    if (lastDelimiter !== delimiterType) {
      resultArray.push({ type: 'delimiter', delimiterType })
      lastDelimiter = delimiterType
    }

    // Insert the actual object
    resultArray.push(obj)
  })

  return resultArray
}

const ChatsList = ({
  chats,
  selectedChatId,
  deleteEntity,
  username,
  customVrRole,
  selectChat,
  toggleDrawer,
}) => {
  const [hoveredItemId, setHoveredItemId] = useState(null)
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)
  const [menuOpenForId, setMenuOpenForId] = useState(null)

  const handleMouseEnter = useCallback(itemId => {
    setHoveredItemId(itemId)
  }, [])

  const handleMouseLeave = useCallback(() => {
    setHoveredItemId(null)
  }, [])

  const handleMenuOpen = useCallback((event, itemId) => {
    setMenuAnchorEl(event.currentTarget)
    setMenuOpenForId(itemId)
  }, [])

  const handleMenuClose = useCallback(() => {
    setMenuAnchorEl(null)
    setMenuOpenForId(null)
  }, [])

  const handleDelete = useCallback(
    itemId => {
      if (window.confirm('Are you sure you want to delete this chat?')) {
        console.log(`Delete chat with id: ${itemId}`)
        if (itemId === selectedChatId) {
          selectChat(null)
        }

        deleteEntity(
          itemId,
          'openaichat',
          `${DATA_API_URL}/openaichat/${itemId}`,
          'Chat deleted',
        )
      }
      handleMenuClose()
    },
    [handleMenuClose, deleteEntity, selectedChatId, selectChat],
  )

  return (
    <div style={{ width: 250 }}>
      <List>
        {insertDelimiters(chats).map(item => {
          if (item.type === 'delimiter') {
            return (
              <ListSubheader style={{ backgroundColor: '#fff' }} key={`delimiter-${item.delimiterType}`}>
                {item.delimiterType}
              </ListSubheader>
            )
          }
          const firstMessageContent = item.title || item.messages?.[1]?.content

          return (
            <div
              key={`chat-${item.updated_date}`}
              onMouseEnter={() => handleMouseEnter(item.id)}
              onMouseLeave={handleMouseLeave}
              style={{ position: 'relative' }}
            >
              <ListItem
                onClick={() => {
                  selectChat(item.id)
                  toggleDrawer(false)
                }}
                button
                selected={item.id === selectedChatId}
              >
                <ListItemText primaryTypographyProps={{ noWrap: true }}>
                  {firstMessageContent}
                </ListItemText>
              </ListItem>
              {(hoveredItemId === item.id || item.id === selectedChatId) && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <IconButton
                    edge="end"
                    aria-label="more options"
                    size="small"
                    onClick={event => handleMenuOpen(event, item.id)}
                    style={{ padding: 5 }}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </div>
              )}
              <Menu
                anchorEl={menuAnchorEl}
                open={menuOpenForId === item.id}
                onClose={handleMenuClose}
              >
                <MenuItem
                  disabled={
                    customVrRole !== 'acctowner' && item.username !== username
                  }
                  onClick={() => handleDelete(item.id)}
                >
                  <DeleteIcon fontSize="small" style={{ marginRight: 8 }} />
                  Delete
                </MenuItem>
              </Menu>
            </div>
          )
        })}
      </List>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatsList)
